import { createTheme } from '@mui/material/styles';
import { green, grey, red } from '@mui/material/colors';

const rawTheme = createTheme({
  palette: {
    primary: {
      light: '#00AEEF',
      main: '#00AEEF',
      dark: '#00AEEF',
    },
    secondary: {
      light: '#c0d7df47',
      main: '#03232c',
      dark: '#03232c',
    },
    warning: {
      main: '#ffc071',
      dark: '#ffb25e',
    },
    error: {
      light: red[50],
      main: red[500],
      dark: red[700],
    },
    success: {
      light: green[50],
      main: green[500],
      dark: green[700],
    },
  },
  typography: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: 14,
    fontWeightLight: 300, // Work Sans
    fontWeightRegular: 400, // Work Sans
    fontWeightMedium: 700, // Roboto Condensed
  },
});

const fontHeader = {
  color: rawTheme.palette.text.primary,
  fontWeight: rawTheme.typography.fontWeightMedium,
  fontFamily: "'Roboto Condensed', sans-serif",
  textTransform: 'uppercase',
};
const theme = {
  ...rawTheme,
  palette: {
    ...rawTheme.palette,
    background: {
      ...rawTheme.palette.background,
      default: rawTheme.palette.common.white,
      placeholder: grey[200],
    },
  },
  typography: {
    ...rawTheme.typography,
    fontHeader,
    h1: {
      ...rawTheme.typography.h1,
      ...fontHeader,
      letterSpacing: 0,
      fontSize: 60,
      fontFamily: "'Cormorant Infant', sans-serif",
      fontWeight: 900,
      "@media (max-width:600px)": { // Apply when screen width is <= 460px
        fontSize: 40,
      },
    },
    h2: {
      ...rawTheme.typography.h2,
      ...fontHeader,
      fontSize: 48,
      fontFamily: "'Cormorant Infant', sans-serif",
      fontWeight: 800,      
      "@media (max-width:600px)": { // Apply when screen width is <= 460px
        fontSize: 38,
      },
    },
    h3: {
      ...rawTheme.typography.h3,
      ...fontHeader,
      fontSize: 42,
      fontFamily: "'Cormorant Infant', sans-serif",
      fontWeight: 900,
      "@media (max-width:600px)": { // Apply when screen width is <= 460px
        fontSize: 36,
      },
    },
    h4: {
      ...rawTheme.typography.h4,
      ...fontHeader,
      fontSize: 36,
      fontFamily: "'Cormorant Infant', sans-serif",
      fontWeight: 600,     
      // "@media (max-width:600px)": { // Apply when screen width is <= 600px
      //   fontSize: 24,
      // },
      
      "@media (max-width:600px)": { // Apply when screen width is <= 460px
        fontSize: 32,
      },
    },
    h5: {
      ...rawTheme.typography.h5,
      fontSize: 20,
      fontWeight: rawTheme.typography.fontWeightLight,
      fontFamily: "'Cormorant Infant', sans-serif",
      fontWeight: 500,
    },
    h6: {
      ...rawTheme.typography.h6,
      ...fontHeader,
      fontSize: 18,
      fontFamily: "'Cormorant Infant', sans-serif",
      fontWeight: 900,
    },
    subtitle1: {
      ...rawTheme.typography.subtitle1,
      fontSize: 18,
    },
    body1: {
      ...rawTheme.typography.body2,
      fontWeight: rawTheme.typography.fontWeightRegular,
      fontSize: 16,
      fontWeight: 300,
    },
    body2: {
      ...rawTheme.typography.body1,
      fontSize: 14,
      fontWeight: 300,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "'Poppins', sans-serif", // Change to desired font
          fontWeight: 700, // Optional: Adjust weight
          textTransform: "none", // Optional: Disable uppercase
        },
      },
    },
  },
};

export default theme;
